// import React from 'react';
import React, { useEffect, useState } from "react";
import axios from 'axios';
import {
    Link
  } from 'react-router-dom';
  import { Grid } from 'antd-mobile';
  import AppHeader from './AppHeader';



const styles = {
    // bgColor: 'white',
    titleTextColor: "#00008B",
    rowTitleColor: "#00008B",
    // rowContentColor: 'grey',
    // arrowColor: "red",
};

const config = {
    animate: true,
    arrowIcon: "V",
    tabFocus: true
};

let NUM_ROWS = 10;

let URL = "http://thahtaylay.com/";

class AndroidDownloadPage extends React.Component {
    constructor(props) {
            super(props)
            window.BPdata.footerMenu = "HelpCenter";

            this.state = {
                banners: [],
                select_banners: [],
                step: "login",
                message : "",
                title: "",
                promotion_id : 0,

            };

        }

    hisUrl(url) {
        if(localStorage.getItem("route")) {
          let menu = JSON.parse(localStorage.getItem("route"));
          //console.log(menu.length+"-------------")
          if(menu.length === "0") {
            let data = ["/"];
            localStorage.setItem("route", JSON.stringify(data) );
          } else {
            if(menu[menu.length - 1] !== url ){
              menu.push(url)
              localStorage.setItem("route", JSON.stringify(menu) );
            }
          }

          // localStorage.setItem("route", JSON.stringify(menu) );
          // console.log(localStorage.getItem('route'));
        }
       // console.log(localStorage.getItem('route'));
    }


    componentDidMount() {

        if(localStorage.getItem('banners')) {

          if(JSON.parse(localStorage.getItem("banners")) != null) {
            let video_slides = JSON.parse(localStorage.getItem("banners"));
            this.setState({banners: video_slides})
          }
        }


        window.scrollTo(0, 0);


    }



    render() {
        return (
            <div className="page">
                {/* <AppHeader backLink="" titleType="2" title={window.lang.more.share_app} isLoading="false" /> */}
                <div className="page-content">

                    <div className="main-content ">
                        <div className="row">

                            <div className="grid-100 text-center">
                              <div className="p-15">

                            <br />
                            <br />
                            <h2 className="color-theme-gold" style={{ "fontSize": "24px"}}>Android ဖုန်းတွင် ThaHtayLay App ထည့်သွင်းနည်း</h2>
                            <span><br />

                            တစ်ကြိမ်ထည့်သွင်းပြီးပါက Browser မှတဆင့် ဝင်စရာမလိုတော့ဘဲ ဖုန်းမျက်နှာပြင်မှ တိုက်ရိုက် ဝင်ရောက်အသုံးပြုနိုင်ပါပြီ။<br /><br />

                            ⚠️ Chrome Browser ဖြင့် ဆောင်ရွက်ရန် အကြံပြုပါသည်။ <br /> Browser အမျိုးအစားပေါ်မူတည်၍ စာသားအနည်းငယ် ကွဲပြားနိုင်ပါသည်။<br /><br />

                            ၁။ Chrome Browser ကိုဖွင့်ပြီး <a href="https://thahtaylay.com" target="_blank" className="color-blue">https://thahtaylay.com</a> သို့ ဝင်ရောက်ပါ။<br />
                            ၂။ ညာဘက်အပေါ်ထောင့်ရှိ အစက်သုံးစက် (⋮) ကိုနှိပ်ပါ။<br />
                            ၃။ "Install App" (သို့) "Add to Home Screen" ကိုရွေးပါ။<br />
                            ၄။ ပေါ်လာသည့် "Install" (သို့) "Add" ကိုနှိပ်၍ အတည်ပြုပါ။<br /><br />

                            ✅ ဖုန်းမျက်နှာပြင်ပေါ်တွင် ThaHtayLay Icon လေး ရောက်ရှိနေပါပြီ။ <br /> Icon ကိုနှိပ်ပြီး စတင်အသုံးပြုနိုင်ပါပြီ။ <br /></span>
                            <br />
                            <br />
                            <img src="/img/guide/android1.jpg" className="img-responsive" /><br />
                            <span>(အဆင့် ၁)</span><br />
                            <br />
                            <img src="/img/guide/android2.jpg" className="img-responsive" /><br />
                            <span>(အဆင့် ၂)</span><br />
                            <br />
                            <img src="/img/guide/android3.jpg" className="img-responsive" /><br />
                            <span>(အဆင့် ၃)</span><br />
                            <br />
                            <img src="/img/guide/android4.jpg" className="img-responsive" /><br />
                            <span>(အဆင့် ၄)</span><br />
                            <br />
                            <Link to="/" className="btn btn-success grid-50">ပင်မစာမျက်နှာသို့</Link>

                              </div>
                            </div>
                        </div>
                      <br />

                    <br />
                    </div>
                </div>

                <footer  className="App-footer">

                    <div className="App-footer-inner">
                      {/* {window.BPdata.footerMenu} */}
                      <Grid data={window.lang.footer}
                          columnNum={5}
                          renderItem={dataItem => (

                            <Link to={dataItem.url} className="cont-wrap-link hvr-pulse-shrink" style={{width: '100%'}}>
                                  { (window.BPdata.footerMenu === dataItem.check )  ? (dataItem.text == "My Profile") ?  <span className="color-white"><img src={dataItem.icon}  height="25px"/><br />{(this.checklogin()) ? dataItem.text : "Login / Register" }</span> : <span className="text-white"><img src={dataItem.icon_off}  height="25px"/><br /><span >{dataItem.text}</span> </span> : <span className="text-white"><img src={dataItem.icon}  height="25px"/><br />{dataItem.text} </span> }

                            </Link>
                          )}
                        />

                    </div>
                  </footer>
            </div>
        );
    }
}

export default AndroidDownloadPage;

